module.exports = __webpack_public_path__ + "static/media/home-ilustracao-paciente.c0ffd406.png";